export default __webpack_public_path__ + "static/media/mid.7f025285.png";